import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserBalance, getUserOrder } from "../redux/actions/coinDBAction";
import {
  getTradingFee,
  N_createBuyOffer,
  N_createSellOffer,
  N_executeOrder,
} from "../redux/helpers/api_functions_new";
import swal from "sweetalert";
import { mul, round } from "../redux/helpers/Math";
import { getRound } from "../redux/helpers/helper_functions";
import useToastPromise from "../../hooks/toastHook";
import toast from "react-hot-toast";

// Helper function to format number to 6 decimal places with downward rounding
const formatToSixDecimals = (value) => {
  if (!value) return "0";
  const num = parseFloat(value);
  if (isNaN(num)) return "0";
  return Math.floor(num * 1000000) / 1000000;
};

export default function BuyNSell(props) {
  const showToast = useToastPromise();
  function formatNumberWithCommas(number, locales = "en-US") {
    if (isNaN(number)) return number; // Return as is if not a valid number

    const [integerPart, decimalPart] = number.toString().split("."); // Split integer & decimal
    const formattedInteger = new Intl.NumberFormat(locales, {
      useGrouping: true,
    }).format(integerPart);

    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  }

  const { isLoggedIn, user } = useSelector((state) => state.AuthReducer);
  const {
    coins,
    wallet,
    paired_curency_price,
    buymarket,
    sellmarket,
    currency_type,
    campare_currency,
  } = useSelector((state) => state.coinDBReducer);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [feeSetting, setFeeSetting] = useState({});
  const [activeTab, setActiveTab] = useState("market");
  const [modalData, setModalData] = useState({
    atPrice: 0,
    amount: 0,
    coin: [],
    buybalance: 0,
    total: 0,
  });

  const openModal = (atPrice, amount, coin) => {
    setModalData({ atPrice, amount, coin, buybalance, total });
    setIsModalOpen(true);
  };

  const confirmPurchase = () => {
    buyCoin(
      modalData.atPrice,
      modalData.amount,
      modalData.coin[0],
      modalData.coin[1]
    );
    setIsModalOpen(false); // Close the modal after confirming
  };
  const confirmSell = () => {
    sellCoin(
      sellModalData?.atsPrice,
      sellModalData?.asmount,
      sellModalData?.coin1,
      sellModalData?.coin2
    );
    setIsModalOpen1(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const closeModal1 = () => {
    setIsModalOpen1(false);
  };
  const [sellModalData, setSellModalData] = useState({
    atsPrice: 0,
    asmount: 0,
    coin1: [],
    coin2: [],
    buybalance: 0,
    total: 0,
  });

  const openModal1 = (atsPrice, asmount, coin1, coin2) => {
    setSellModalData({ atsPrice, asmount, coin1, coin2 });
    setIsModalOpen1(true);
  };
  const [loading, setLoading] = useState(false);
  const [bloading, setbLoading] = useState(false);
  const [fixedPrice, setFixedPrice] = useState(0);
  const [fixedPriceBoolean, setFixedPriceBoolean] = useState(false);
  const [fixedSPrice, setFixedSPrice] = useState(0);
  const [fixedSPriceBoolean, setFixedSPriceBoolean] = useState(false);
  const [atPrice, setATPrice] = useState(0); //testing 0 to 1
  const [atsPrice, setATSPrice] = useState(0);
  const [cprice, setCprice] = useState(0); //testing 0 to 1
  const [amount, setAmount] = useState("");
  const [asmount, setSAmount] = useState("");
  const [total, setTotal] = useState("");
  const [stotal, setSTotal] = useState("");
  const [stopLimit, setStoplimit] = useState(0);
  const [wallet_details, setWalletDetails] = useState([]);
  const [buybalance, setbuybalance] = useState(0);
  const [sellbalance, setsellbalance] = useState(0);
  const coin = props?.match?.params?.id
    ? props.match.params.id.split("-")
    : currency_type + "-" + campare_currency.split("-");
  const [price, setprice] = useState(0);
  let time = 0;

  function setCurrentBuySellTokenBalance() {
    wallet_details.forEach((item, i) => {
      if (item.symbol === coin[1]?.toUpperCase()) {
        setbuybalance(getRound(item.balance));
      } else if (item.symbol === coin[0]?.toUpperCase()) {
        setsellbalance(getRound(item.balance));
      }
    });
  }
  const saveSettings = async () => {
    // Simulating an API call
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return "Settings saved!";
  };

  function getCurrentBuySellTokenBalance() {
    let final_data =
      wallet &&
      Object.keys(wallet).map((res, i) => {
        return {
          id: wallet[res]?.id,
          icon: wallet[res]?.icon,
          symbol: wallet[res]?.symbol.toUpperCase(),
          name: wallet[res]?.name,
          status: wallet[res]?.status,
          withdral_fee: wallet[res]?.withdrawal_fee,
          locked: getRound(wallet[res]?.locked),
          address: wallet[res]?.wallet_address,
          balance: getRound(wallet[res]?.balance),
          avl_balance: getRound(wallet[res]?.balance - wallet[res]?.locked),
        };
      });
    setWalletDetails(final_data);
    setTimeout(() => setLoading(false), 800);
  }

  useEffect(() => {
    setCurrentBuySellTokenBalance("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coin, wallet_details]);

  useEffect(() => {
    Object.values(coins)?.map((d, i) => {
      if (d.symbol === coin[0].toUpperCase()) {
        setprice(
          Number(d.current_price) /
          Number(
            paired_curency_price
              ? paired_curency_price[coin[1].toUpperCase()]
                ? paired_curency_price[coin[1].toUpperCase()]
                : 1
              : 1
          )
        );
      }
    });
  }, [coins, coin]);

  useEffect(() => {
    if (price && time == 0) {
      setATPrice(getRound(price));
      setATSPrice(getRound(price));
      setCprice(getRound(price));
      time = 1;
    }
  }, [price, wallet]);

  useEffect(() => {
    if (isLoggedIn && user?.params ? user.params.user_id : user.user_id) {
      getCurrentBuySellTokenBalance();
    }
  }, [wallet]);

  const getFeeSettings = async () => {
    const res = await getTradingFee(coin?.[0]?.toUpperCase());
    setFeeSetting({
      taker_fee: res?.setting?.taker_fee ?? 0,
      maker_fee: res?.setting?.maker_fee ?? 0,
    });
  };
  useEffect(() => {
    const mprice = round(buymarket.marketprice);
    const mvolume = round(buymarket.marketvolume);
    const totalinr = mul(mvolume, mprice);
    setATSPrice(mprice);
    setSAmount(mvolume);
    setSTotal(totalinr);
    getFeeSettings();
  }, [buymarket]);

  useEffect(() => {
    const mprice = round(sellmarket.marketprice);
    const mvolume = round(sellmarket.marketvolume);
    const totalinr = mul(mvolume, mprice);
    setATPrice(mprice);
    setAmount(mvolume);
    setTotal(totalinr);
  }, [sellmarket]);

  useEffect(() => {
    setAmount(0)
    setTotal(0)
  }, [activeTab]);

  function buyCoin(atPrice, amount, c, cp) {
    setbLoading(true);
    N_createBuyOffer(
      atPrice,
      amount,
      c,
      cp,
      user?.params ? user.params.user_id : user.user_id,
      cprice,
      total,
      activeTab === "market" ? 0 : 1
    )
      .then((d) => {
        if (d.status == 200) {
          // toast.success(d.message);
          showToast(saveSettings, {
            loading: "Processing...",
            success: d?.message,
            error: "Failed.....",
          });
          getCurrentBuySellTokenBalance();
          dispatch(
            getUserBalance(user?.params ? user.params.user_id : user.user_id)
          );
          dispatch(
            getUserOrder(user?.params ? user.params.user_id : user.user_id)
          );
          N_executeOrder(
            d.result.order_id,
            user?.params ? user.params.user_id : user.user_id,
            d.result.type
          ).then((d) => {
            if (d.status == 200) {
              getCurrentBuySellTokenBalance();
              dispatch(
                getUserBalance(
                  user?.params ? user.params.user_id : user.user_id
                )
              );
              dispatch(
                getUserOrder(user?.params ? user.params.user_id : user.user_id)
              );
            }
          });
        } else if (d.status == 400) {
          getCurrentBuySellTokenBalance();
          dispatch(
            getUserBalance(user?.params ? user.params.user_id : user.user_id)
          );
          dispatch(
            getUserOrder(user?.params ? user.params.user_id : user.user_id)
          );
          toast.error(d.message);
          // swal({
          //   text: d.message,
          //   icon: "error",
          //   timer: 2000, // Close after 2 seconds
          //   buttons: false, // Hides the buttons
          //   customClass: {
          //     popup: "dark-modal",
          //     backdrop: "dark-backdrop",
          //   },
          // });
        }
        setbLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  function sellCoin(atPrice, amount, c, cp) {
    setLoading(true);
    N_createSellOffer(
      atPrice,
      amount,
      c,
      cp,
      user?.params ? user.params.user_id : user.user_id,
      cprice,
      undefined,
      activeTab === "market" ? 0 : 1,
      stotal
    )
      .then((d) => {
        if (d.status == 200) {
          // toast.success(d.message);
          showToast(saveSettings, {
            loading: "Processing...",
            success: d?.message,
            error: "Failed.....",
          });
          getCurrentBuySellTokenBalance();
          dispatch(
            getUserBalance(user?.params ? user.params.user_id : user.user_id)
          );
          dispatch(
            getUserOrder(user?.params ? user.params.user_id : user.user_id)
          );
          N_executeOrder(
            d.result.order_id,
            user?.params ? user.params.user_id : user.user_id,
            d.result.type
          ).then((d) => {
            if (d.status == 200) {
              getCurrentBuySellTokenBalance();
              dispatch(
                getUserBalance(
                  user?.params ? user.params.user_id : user.user_id
                )
              );
              dispatch(
                getUserOrder(user?.params ? user.params.user_id : user.user_id)
              );
            }
          });
        } else if (d.status == 400) {
          getCurrentBuySellTokenBalance();
          dispatch(
            getUserBalance(user?.params ? user.params.user_id : user.user_id)
          );
          dispatch(
            getUserOrder(user?.params ? user.params.user_id : user.user_id)
          );
          // toast.success(d.message);
          swal({
            text: d.message,
            icon: "error",
            timer: 2000, // Close after 2 seconds
            buttons: false, // Hides the buttons
            customClass: {
              popup: "dark-modal",
              backdrop: "dark-backdrop",
            },
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  return (
    <>
      <div style={{ height: "100%" }} className="ps-1 py-0">
        <div className="card order_book ">
          {/* <div
            style={{ fontWeight: "600", fontSize: "24px" }}
            className="card-header"
          >
            Market
          </div> */}
          <div className="tabs card-header p-0">
            <button
              className={activeTab === "market" ? "active" : ""}
              onClick={() => setActiveTab("market")}
            >
              Market
            </button>
            <button
              className={activeTab === "limit" ? "active" : ""}
              onClick={() => setActiveTab("limit")}
            >
              Limit
            </button>
          </div>

          {activeTab == "market" ? (
            <div className="card-body " id="open-order">
              <div className="row">
                <div className="col-12 mt-4">
                  <div className="">
                    <select
                      className="custom-select bg-light text-secondary border buy-sell-form-bg buy-sell-theme d-none"
                      value={stopLimit}
                      onChange={(e) =>
                        setStoplimit(
                          e.target.value
                            .replace(/[^0-9.]/g, "")
                            .replace(/(\..*?)\..*/g, "$1")
                        )
                      }
                    >
                      <option value={0}>Limit</option>
                      <option value={1}>Stop Limit</option>
                    </select>
                  </div>
                  <div className="">
                    {stopLimit === 1 ? (
                      <div className="input-group exchange_input_grp mb-2">
                        <span className="input-group-text">STOP PRICE</span>

                        <input
                          type="text"
                          className="form-control buy-sell-form-bg buy-sell-theme"
                          value="0"
                        />
                        <span className="input-group-text">INR</span>
                      </div>
                    ) : null}

                    <div className="input-group mb-3 exchange_input_grp">
                      <span className="input-group-text buy-sell-form-bg buy-sell-theme">
                        Amount
                      </span>

                      <input
                        type="text"
                        className="form-control buy-sell-form-bg buy-sell-theme"
                        value={amount == "" ? "" : amount}
                        placeholder="0"
                        onChange={(e) => {
                          const formattedValue = formatToSixDecimals(
                            e.target.value
                              .replace(/[^0-9.]/g, "")
                              .replace(/(\..*?)\..*/g, "$1")
                          );
                          setAmount(formattedValue);
                          setTotal(
                            formatToSixDecimals(
                              parseFloat(formattedValue) * atPrice
                            )
                          );
                        }}
                      />

                      <span className="input-group-text">
                        {coin[0].toUpperCase()}
                      </span>
                    </div>
                    <div className="input-group mb-3 exchange_input_grp">
                      <span className="input-group-text buy-sell-form-bg buy-sell-theme ">
                        Total
                      </span>

                      <input
                        type="text"
                        className="form-control buy-sell-form-bg buy-sell-theme "
                        placeholder="0"
                        value={total == "" ? "" : total}
                        onChange={(e) => {
                          const formattedValue = formatToSixDecimals(
                            e.target.value
                              .replace(/[^0-9.]/g, "")
                              .replace(/(\..*?)\..*/g, "$1")
                          );
                          setAmount(
                            formatToSixDecimals(
                              parseFloat(formattedValue) / atPrice
                            )
                          );
                          setTotal(formattedValue);
                        }}
                      />

                      <span className="input-group-text">
                        {coin[1].toUpperCase()}
                      </span>
                    </div>

                    {isLoggedIn ? (
                      <>
                        <div className="row mt-2  text-muted">
                          <div className="col-12 d-flex justify-content-between">
                            <div
                              className="buy_sell_amount_picker"
                              onClick={() => {
                                const newTotal = formatToSixDecimals(
                                  Number(buybalance ? buybalance * 0.25 : 0)
                                );
                                setTotal(newTotal);
                                setAmount(
                                  formatToSixDecimals(
                                    Number(
                                      (buybalance ? buybalance * 0.25 : 0) /
                                      atPrice
                                    )
                                  )
                                );
                              }}
                            >
                              25%
                            </div>
                            <div
                              className="buy_sell_amount_picker"
                              onClick={() => {
                                const newTotal = formatToSixDecimals(
                                  Number(buybalance ? buybalance * 0.5 : 0)
                                );
                                setTotal(newTotal);
                                setAmount(
                                  formatToSixDecimals(
                                    Number(
                                      (buybalance ? buybalance * 0.5 : 0) /
                                      atPrice
                                    )
                                  )
                                );
                              }}
                            >
                              50%
                            </div>
                            <div
                              className="buy_sell_amount_picker btn btn-default"
                              onClick={() => {
                                const newTotal = formatToSixDecimals(
                                  Number(buybalance ? buybalance * 0.75 : 0)
                                );
                                setTotal(newTotal);
                                setAmount(
                                  formatToSixDecimals(
                                    Number(
                                      (buybalance ? buybalance * 0.75 : 0) /
                                      atPrice
                                    )
                                  )
                                );
                              }}
                            >
                              75%
                            </div>
                            <div
                              className="buy_sell_amount_picker"
                              onClick={() => {
                                const newTotal = formatToSixDecimals(
                                  Number(buybalance ? buybalance : 0)
                                );
                                setTotal(newTotal);
                                setAmount(
                                  formatToSixDecimals(
                                    Number(
                                      buybalance ? buybalance / atPrice : 0
                                    )
                                  )
                                );
                              }}
                            >
                              100%
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3 text-muted">
                          <div className="col-lg-6">
                            <span className="fs-12">
                              Buy {coin[0].toUpperCase()}
                            </span>
                          </div>
                          <div className="col-lg-6 text-end fs-12">
                            {/* <span className="mx-2" title="wallet">
                            <i className="fa fa-wallet"> </i>
                          </span> */}
                            {coin[1] !== campare_currency
                              ? formatNumberWithCommas(buybalance) +
                              " " +
                              coin[1].toUpperCase()
                              : formatNumberWithCommas(buybalance) +
                              " " +
                              campare_currency.toUpperCase()}
                          </div>
                        </div>
                      </>
                    ) : null}

                    <div className="d-grid mt-2">
                      <button
                        style={{
                          background: "#20ac95",
                          border: "1px solid #20ac95",
                          color: "#fff",
                        }}
                        className="btn "
                        disabled={bloading || !total || parseFloat(total) < 0.001}
                        onClick={() => {
                          if (isLoggedIn) {
                            openModal(atPrice, amount, coin, buybalance, total);
                          } else {
                            toast.error("First login then perform buy/sell");
                          }
                        }}
                      >
                        {bloading ? (
                          <i className="loading-icon fas fa-spinner fa-spin mr-2"></i>
                        ) : null}
                        BUY {coin[0].toUpperCase()}
                      </button>
                    </div>
                    <div className="text-muted text-center small mt-1">
                      Fee: Maker fee: {feeSetting?.maker_fee}%| Taker fee:{" "}
                      {feeSetting?.taker_fee}%
                    </div>
                  </div>
                </div>

                <div className="col-12 mt-5">
                  {/* sell tab */}

                  <div id="order-history">
                    <div className="">
                      <div className="input-group mb-3 exchange_input_grp">
                        <span className="input-group-text buy-sell-form-bg buy-sell-theme">
                          Amount
                        </span>

                        <input
                          type="text"
                          className="form-control buy-sell-form-bg buy-sell-theme"
                          value={asmount == "" ? "" : asmount}
                          placeholder="0"
                          onChange={(e) => {
                            const formattedValue = formatToSixDecimals(
                              e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*?)\..*/g, "$1")
                            );
                            setSAmount(formattedValue);
                            setSTotal(
                              formatToSixDecimals(
                                parseFloat(formattedValue) * atPrice
                              )
                            );
                          }}
                        />
                        <span className="input-group-text">
                          {" "}
                          {coin[0].toUpperCase()}
                        </span>
                      </div>

                      <div className="input-group mb-3 exchange_input_grp">
                        <span className="input-group-text buy-sell-form-bg buy-sell-theme">
                          Total
                        </span>

                        <input
                          type="text"
                          className="form-control buy-sell-form-bg buy-sell-theme"
                          value={stotal == "" ? "" : stotal}
                          placeholder="0"
                          onChange={(e) => {
                            const formattedValue = formatToSixDecimals(
                              e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*?)\..*/g, "$1")
                            );
                            setSAmount(
                              formatToSixDecimals(
                                parseFloat(formattedValue) / atsPrice
                              )
                            );
                            setSTotal(formattedValue);
                          }}
                        />
                        <span className="input-group-text">
                          {coin[1].toUpperCase()}
                        </span>
                      </div>
                      {isLoggedIn ? (
                        <>
                          <div className="row">
                            <div className="col-12 d-flex justify-content-between">
                              <span
                                className="buy_sell_amount_picker"
                                onClick={() => {
                                  const newTotal = formatToSixDecimals(
                                    Number(sellbalance ? sellbalance * 0.25 : 0)
                                  );
                                  setSAmount(newTotal);
                                  setSTotal(
                                    formatToSixDecimals(
                                      Number(
                                        (sellbalance ? atsPrice * sellbalance * 0.25 : 0)
                                      )
                                    )
                                  );
                                }}
                              >
                                25%
                              </span>
                              <span
                                className="px-1 buy_sell_amount_picker"
                                onClick={() => {
                                  const newTotal = formatToSixDecimals(
                                    Number(sellbalance ? sellbalance * 0.5 : 0)
                                  );
                                  setSAmount(newTotal);
                                  setSTotal(
                                    formatToSixDecimals(
                                      Number(
                                        (sellbalance ? atsPrice * sellbalance * 0.5 : 0)
                                      )
                                    )
                                  );
                                }}
                              >
                                50%
                              </span>
                              <span
                                className="pl-1 buy_sell_amount_picker"
                                onClick={() => {
                                  const newTotal = formatToSixDecimals(
                                    Number(sellbalance ? sellbalance * 0.75 : 0)
                                  );
                                  setSAmount(newTotal);
                                  setSTotal(
                                    formatToSixDecimals(
                                      Number(
                                        (sellbalance ? atsPrice * sellbalance * 0.75 : 0)
                                      )
                                    )
                                  );
                                }}
                              >
                                75%
                              </span>
                              <span
                                className="pl-1 buy_sell_amount_picker"
                                onClick={() => {
                                  const newTotal = formatToSixDecimals(
                                    Number(sellbalance ? sellbalance : 0)
                                  );
                                  setSAmount(newTotal);
                                  setSTotal(
                                    formatToSixDecimals(
                                      Number(
                                        (sellbalance ? atsPrice * sellbalance : 0)
                                      )
                                    )
                                  );
                                }}
                              >
                                100%
                              </span>
                            </div>
                          </div>
                          <div className="row mt-3 text-muted">
                            <div className="col-lg-6">
                              <span className="fs-12">
                                Sell {coin[0].toUpperCase()}
                              </span>
                            </div>
                            <div className="col-6 text-end fs-12">
                              {/* <span className="me-2" title="wallet">
                            <i className="fa fa-wallet"> </i>
                          </span> */}
                              {sellbalance
                                ? coin[1] !== campare_currency
                                  ? formatNumberWithCommas(sellbalance)
                                  : formatNumberWithCommas(sellbalance)
                                : 0}{" "}
                              {coin[0].toUpperCase()}
                            </div>{" "}
                          </div>
                        </>
                      ) : null}

                      <div className="d-grid mt-2">
                        <button
                          style={{
                            background: "#e2464a",
                            border: "1px solid #e2464a",
                            color: "#fff",
                          }}
                          className="btn  text-whtie"
                          disabled={
                            loading || !stotal || parseFloat(stotal) < 0.001
                          }
                          onClick={() => {
                            if (isLoggedIn) {
                              // sellCoin(atsPrice, asmount, coin[0], coin[1]);
                              openModal1(atsPrice, asmount, coin[0], coin[1]);
                            } else {
                              toast.error("First login then perform buy/sell");
                            }
                          }}
                        >
                          {loading ? (
                            <i className="loading-icon fas fa-spinner fa-spin mr-2"></i>
                          ) : null}
                          SELL {coin[0].toUpperCase()}
                        </button>
                      </div>
                      <div className="text-muted small text-center mt-1 mb-2">
                        Fee: Maker fee: {feeSetting?.maker_fee}%| Taker fee:{" "}
                        {feeSetting?.taker_fee}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="card-body " id="open-order">
              <div className="row">
                <div className="col-12 mt-4">
                  <div className="">
                    <select
                      className="custom-select bg-light text-secondary border buy-sell-form-bg buy-sell-theme d-none"
                      value={stopLimit}
                      onChange={(e) =>
                        setStoplimit(
                          e.target.value
                            .replace(/[^0-9.]/g, "")
                            .replace(/(\..*?)\..*/g, "$1")
                        )
                      }
                    >
                      <option value={0}>Limit</option>
                      <option value={1}>Stop Limit</option>
                    </select>
                  </div>
                  <div className="">
                    {stopLimit === 1 ? (
                      <div className="input-group exchange_input_grp mb-2">
                        <span className="input-group-text">STOP PRICE</span>

                        <input
                          type="text"
                          className="form-control buy-sell-form-bg buy-sell-theme"
                          value="0"
                        />
                        <span className="input-group-text">INR</span>
                      </div>
                    ) : null}

                    <div className="input-group mb-3 exchange_input_grp">
                      <span className="input-group-text buy-sell-form-bg buy-sell-theme">
                        Price
                      </span>

                      <input
                        type="text"
                        className="form-control buy-sell-form-bg buy-sell-theme"
                        value={!fixedPriceBoolean ? atPrice : fixedPrice}
                        onChange={(e) => {
                          setFixedPrice(
                            e.target.value
                              .replace(/[^0-9.]/g, "")
                              .replace(/(\..*?)\..*/g, "$1")
                          );
                          setFixedPriceBoolean(true);

                          setATPrice(
                            e.target.value
                              .replace(/[^0-9.]/g, "")
                              .replace(/(\..*?)\..*/g, "$1")
                          );
                          setTotal(
                            e.target.value
                              .replace(/[^0-9.]/g, "")
                              .replace(/(\..*?)\..*/g, "$1") * amount
                          );
                        }}
                      />
                      <span className="input-group-text bg-transparent">
                        {coin[1].toUpperCase()}
                      </span>
                    </div>
                    <div className="input-group mb-3 exchange_input_grp">
                      <span className="input-group-text buy-sell-form-bg buy-sell-theme">
                        Amount
                      </span>

                      <input
                        type="text"
                        className="form-control buy-sell-form-bg buy-sell-theme"
                        value={amount}
                        onChange={(e) => {
                          const formattedValue = formatToSixDecimals(
                            e.target.value
                              .replace(/[^0-9.]/g, "")
                              .replace(/(\..*?)\..*/g, "$1")
                          );
                          setAmount(formattedValue);
                          setTotal(
                            formatToSixDecimals(
                              parseFloat(formattedValue) *
                              (!fixedPriceBoolean ? atPrice : fixedPrice)
                            )
                          );
                        }}
                      />

                      <span className="input-group-text">
                        {coin[0].toUpperCase()}
                      </span>
                    </div>
                    <div className="input-group mb-3 exchange_input_grp">
                      <span className="input-group-text buy-sell-form-bg buy-sell-theme ">
                        Total
                      </span>

                      <input
                        type="text"
                        className="form-control buy-sell-form-bg buy-sell-theme "
                        value={total}
                        onChange={(e) => {
                          const formattedValue = formatToSixDecimals(
                            e.target.value
                              .replace(/[^0-9.]/g, "")
                              .replace(/(\..*?)\..*/g, "$1")
                          );
                          setAmount(
                            formatToSixDecimals(
                              parseFloat(formattedValue) /
                              (!fixedPriceBoolean ? atPrice : fixedPrice)
                            )
                          );
                          setTotal(formattedValue);
                        }}
                      />

                      <span className="input-group-text">
                        {coin[1].toUpperCase()}
                      </span>
                    </div>

                    {isLoggedIn ? (
                      <>
                        <div className="row mt-2  text-muted">
                          <div className="col-12 d-flex justify-content-between">
                            <div
                              className="buy_sell_amount_picker"
                              onClick={() => {
                                const newTotal = formatToSixDecimals(
                                  Number(buybalance ? buybalance * 0.25 : 0)
                                );
                                setTotal(newTotal);
                                setAmount(
                                  formatToSixDecimals(
                                    Number(
                                      (buybalance ? buybalance * 0.25 : 0) /
                                      (!fixedPriceBoolean ? atPrice : fixedPrice)
                                    )
                                  )
                                );
                              }}
                            >
                              25%
                            </div>
                            <div
                              className="buy_sell_amount_picker"
                              onClick={() => {
                                const newTotal = formatToSixDecimals(
                                  Number(buybalance ? buybalance * 0.5 : 0)
                                );
                                setTotal(newTotal);
                                setAmount(
                                  formatToSixDecimals(
                                    Number(
                                      (buybalance ? buybalance * 0.5 : 0) /
                                      (!fixedPriceBoolean ? atPrice : fixedPrice)
                                    )
                                  )
                                );
                              }}
                            >
                              50%
                            </div>
                            <div
                              className="buy_sell_amount_picker btn btn-default"
                              onClick={() => {
                                const newTotal = formatToSixDecimals(
                                  Number(buybalance ? buybalance * 0.75 : 0)
                                );
                                setTotal(newTotal);
                                setAmount(
                                  formatToSixDecimals(
                                    Number(
                                      (buybalance ? buybalance * 0.75 : 0) /
                                      (!fixedPriceBoolean ? atPrice : fixedPrice)
                                    )
                                  )
                                );
                              }}
                            >
                              75%
                            </div>
                            <div
                              className="buy_sell_amount_picker"
                              onClick={() => {
                                const newTotal = formatToSixDecimals(
                                  Number(buybalance ? buybalance : 0)
                                );
                                setTotal(newTotal);
                                setAmount(
                                  formatToSixDecimals(
                                    Number(
                                      (buybalance ? buybalance : 0) /
                                      (!fixedPriceBoolean ? atPrice : fixedPrice)
                                    )
                                  )
                                );
                              }}
                            >
                              100%
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3 text-muted">
                          <div className="col-lg-6">
                            <span className="fs-12">
                              Buy {coin[0].toUpperCase()}
                            </span>
                          </div>
                          <div className="col-lg-6 text-end fs-12">
                            {/* <span className="mx-2" title="wallet">
                            <i className="fa fa-wallet"> </i>
                          </span> */}
                            {coin[1] !== campare_currency
                              ? buybalance + " " + coin[1].toUpperCase()
                              : buybalance +
                              " " +
                              campare_currency.toUpperCase()}
                          </div>
                        </div>
                      </>
                    ) : null}

                    <div className="d-grid mt-2">
                      <button
                        style={{
                          background: "#20ac95",
                          border: "1px solid #20ac95",
                          color: "#fff",
                        }}
                        className="btn "
                        disabled={!total || parseFloat(total) < 0.001}
                        // disabled={bloading}
                        onClick={() => {
                          if (isLoggedIn) {
                            openModal(
                              !fixedPriceBoolean ? atPrice : fixedPrice,
                              amount,
                              coin,
                              buybalance,
                              total
                            );
                          } else {
                            toast.error("First login then perform buy/sell");
                          }
                        }}
                      >
                        {bloading ? (
                          <i className="loading-icon fas fa-spinner fa-spin mr-2"></i>
                        ) : null}
                        BUY {coin[0].toUpperCase()}
                      </button>
                    </div>
                    <div className="text-muted text-center small mt-1">
                      Fee: Maker fee: {feeSetting?.maker_fee}%| Taker fee:{" "}
                      {feeSetting?.taker_fee}%
                    </div>
                  </div>
                </div>

                <div className="col-12 mt-5">
                  {/* sell tab */}

                  <div id="order-history">
                    <div className="">
                      <div className="input-group mb-3 exchange_input_grp">
                        <span className="input-group-text buy-sell-form-bg buy-sell-theme">
                          Price
                        </span>

                        <input
                          type="text"
                          className="form-control buy-sell-form-bg buy-sell-theme"
                          value={!fixedSPriceBoolean ? atsPrice : fixedSPrice}
                          onChange={(e) => {
                            setFixedSPriceBoolean(true);
                            setFixedSPrice(
                              e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*?)\..*/g, "$1")
                            );
                            setATSPrice(
                              e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*?)\..*/g, "$1")
                            );
                            setSTotal(
                              e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*?)\..*/g, "$1") * asmount
                            );
                          }}
                        />
                        <div className="input-group-text">
                          {coin[1].toUpperCase()}
                        </div>
                      </div>
                      <div className="input-group mb-3 exchange_input_grp">
                        <span className="input-group-text buy-sell-form-bg buy-sell-theme">
                          Amount
                        </span>
                        <input
                          type="text"
                          className="form-control buy-sell-form-bg buy-sell-theme"
                          value={asmount}
                          onChange={(e) => {
                            const formattedValue = formatToSixDecimals(
                              e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*?)\..*/g, "$1")
                            );
                            setSAmount(formattedValue);
                            setSTotal(
                              formatToSixDecimals(
                                parseFloat(formattedValue) *
                                (!fixedSPriceBoolean ? atsPrice : fixedSPrice)
                              )
                            );
                          }}
                        />
                        <span className="input-group-text">
                          {" "}
                          {coin[0].toUpperCase()}
                        </span>
                      </div>

                      <div className="input-group mb-3 exchange_input_grp">
                        <span className="input-group-text buy-sell-form-bg buy-sell-theme">
                          Total
                        </span>

                        <input
                          type="text"
                          className="form-control buy-sell-form-bg buy-sell-theme"
                          value={stotal}
                          onChange={(e) => {
                            const formattedValue = formatToSixDecimals(
                              e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*?)\..*/g, "$1")
                            );
                            setSAmount(
                              formatToSixDecimals(
                                parseFloat(formattedValue) /
                                (!fixedSPriceBoolean ? atsPrice : fixedSPrice)
                              )
                            );
                            setSTotal(formattedValue);
                          }}
                        />
                        <span className="input-group-text">
                          {coin[1].toUpperCase()}
                        </span>
                      </div>
                      {isLoggedIn ? (
                        <>
                          <div className="row">
                            <div className="col-12 d-flex justify-content-between">
                              <span
                                className="buy_sell_amount_picker"
                                onClick={() => {
                                  const newTotal = formatToSixDecimals(
                                    Number(sellbalance ? sellbalance * 0.25 : 0)
                                  );
                                  setSAmount(newTotal);
                                  setSTotal(
                                    formatToSixDecimals(
                                      Number(
                                        (sellbalance ? atsPrice * sellbalance * 0.25 : 0)
                                      )
                                    )
                                  );
                                }}
                              >
                                25%
                              </span>
                              <span
                                className="px-1 buy_sell_amount_picker"
                                onClick={() => {
                                  const newTotal = formatToSixDecimals(
                                    Number(sellbalance ? sellbalance * 0.5 : 0)
                                  );
                                  setSAmount(newTotal);
                                  setSTotal(
                                    formatToSixDecimals(
                                      Number(
                                        (sellbalance ? atsPrice * sellbalance * 0.5 : 0)
                                      )
                                    )
                                  );
                                }}
                              >
                                50%
                              </span>
                              <span
                                className="pl-1 buy_sell_amount_picker"
                                onClick={() => {
                                  const newTotal = formatToSixDecimals(
                                    Number(sellbalance ? sellbalance * 0.75 : 0)
                                  );
                                  setSAmount(newTotal);
                                  setSTotal(
                                    formatToSixDecimals(
                                      Number(
                                        (sellbalance ? atsPrice * sellbalance * 0.75 : 0)
                                      )
                                    )
                                  );
                                }}
                              >
                                75%
                              </span>
                              <span
                                className="pl-1 buy_sell_amount_picker"
                                onClick={() => {
                                  const newTotal = formatToSixDecimals(
                                    Number(sellbalance ? sellbalance : 0)
                                  );
                                  setSAmount(newTotal);
                                  setSTotal(
                                    formatToSixDecimals(
                                      Number(
                                        (sellbalance ? atsPrice * sellbalance : 0)
                                      )
                                    )
                                  );
                                }}
                              >
                                100%
                              </span>
                            </div>
                          </div>
                          <div className="row mt-3 text-muted">
                            <div className="col-lg-6">
                              <span className="fs-12">
                                Sell {coin[0].toUpperCase()}
                              </span>
                            </div>
                            <div className="col-6 text-end fs-12">
                              {/* <span className="me-2" title="wallet">
                            <i className="fa fa-wallet"> </i>
                          </span> */}
                              {sellbalance
                                ? coin[1] !== campare_currency
                                  ? sellbalance
                                  : sellbalance
                                : 0}{" "}
                              {coin[0].toUpperCase()}
                            </div>{" "}
                          </div>
                        </>
                      ) : null}

                      <div className="d-grid mt-2">
                        <button
                          style={{
                            background: "#e2464a",
                            border: "1px solid #e2464a",
                            color: "#fff",
                          }}
                          className="btn text-white"
                          disabled={
                            loading || !stotal || parseFloat(stotal) < 0.001
                          }
                          onClick={() => {
                            if (isLoggedIn) {
                              // sellCoin(atsPrice, asmount, coin[0], coin[1]);
                              openModal1(
                                !fixedSPriceBoolean ? atsPrice : fixedSPrice,
                                asmount,
                                coin[0],
                                coin[1]
                              );
                            } else {
                              toast.error("First login then perform buy/sell");
                            }
                          }}
                        >
                          {loading ? (
                            <i className="loading-icon fas fa-spinner fa-spin mr-2"></i>
                          ) : null}
                          SELL {coin[0].toUpperCase()}
                        </button>
                      </div>
                      <div className="text-muted small text-center mt-1 mb-2">
                        Fee: Maker fee: {feeSetting?.maker_fee}%| Taker fee:{" "}
                        {feeSetting?.taker_fee}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div>
        {/* Modal */}
        <div
          className={`modal  fade no-scroll bg-blur ${isModalOpen ? "show d-block" : ""
            }`}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="paymentmodal2"
          aria-hidden={!isModalOpen}
          style={{ display: isModalOpen ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              className="modal-content first_registration_section comming-soon-bg p-2"
              style={{ background: "#1f1f1f", border: "1px solid white" }}
            >
              <div className="modal-body text-white">
                <div className="first_registration_heading_section">
                  <div className="my-2">
                    <img
                      alt=""
                      style={{ width: "80px", marginBottom: "18px" }}
                      src="/img/logo.svg"
                    />
                  </div>
                  <div className="jambotron-outline" style={{ border: "none" }}>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Price</div>
                      <div>{modalData?.atPrice} USDT</div>
                    </div>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Amount</div>
                      <div>
                        {Number(modalData?.amount)?.toFixed(6)}{" "}
                        {modalData?.coin[0]?.toUpperCase()}
                      </div>
                    </div>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Order Value</div>
                      <div>{Number(modalData?.total)?.toFixed(4)} USDT</div>
                    </div>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Total Payment</div>
                      <div>{Number(modalData?.total)?.toFixed(4)} USDT</div>
                    </div>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Trading Fees</div>
                      <div>
                        {(
                          (Number(modalData?.amount) / 100) *
                          Number(feeSetting?.maker_fee)
                        )?.toFixed(
                          (Number(modalData?.amount) / 100) *
                            Number(feeSetting?.maker_fee) >
                            0
                            ? 10
                            : 4
                        )}{" "}
                        {modalData?.coin[0]?.toUpperCase()}
                      </div>
                    </div>
                    <li
                      className="my-3"
                      style={{ borderBottom: "1px solid white" }}
                    ></li>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Fund Account balance</div>
                      <div>{modalData?.buybalance} USDT</div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end gap-4">
                    <button
                      onClick={() => setIsModalOpen(false)}
                      className="btn"
                      style={{
                        background: "white",
                        border: "none",
                        color: "black",
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      style={{ background: "#20ac95" }}
                      onClick={confirmPurchase}
                      className="btn btn-success"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Backdrop */}
        {isModalOpen && (
          <div className="modal-backdrop fade show" onClick={closeModal}></div>
        )}
      </div>
      {/* end  */}

      {/* sell Modal */}
      <div>
        <div
          className={`modal  fade no-scroll bg-blur ${isModalOpen1 ? "show d-block" : ""
            }`}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="paymentmodal2"
          aria-hidden={!isModalOpen1}
          style={{ display: isModalOpen1 ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content first_registration_section comming-soon-bg p-2">
              <div className="modal-body text-white">
                <div className="first_registration_heading_section">
                  <div className="my-2">
                    <img
                      alt=""
                      style={{ width: "80px", marginBottom: "18px" }}
                      src="/img/logo.svg"
                    />
                  </div>
                  <div className="jambotron-outline">
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Price</div>
                      <div>{sellModalData?.atsPrice} USDT</div>
                    </div>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Amount</div>
                      <div>
                        {Number(sellModalData?.asmount)?.toFixed(6)}{" "}
                        {/* {(sellModalData?.coin1 && sellModalData?.coin1?.toUpperCase())} */}
                      </div>
                    </div>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Sell Order Value</div>
                      <div className="text-uppercase">
                        {Number(sellModalData?.asmount)?.toFixed(6)}{" "}
                        {sellModalData?.coin1 && sellModalData?.coin1}
                      </div>
                    </div>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Trading Fees</div>
                      <div className="text-uppercase">
                        {(
                          (Number(sellModalData?.asmount) / 100) *
                          Number(feeSetting?.taker_fee)
                        )?.toFixed(
                          (Number(sellModalData?.asmount) / 100) *
                            Number(feeSetting?.taker_fee) >
                            0
                            ? 10
                            : 4
                        )}{" "}
                        {sellModalData?.coin1 && sellModalData?.coin1}
                      </div>
                    </div>

                    <li className="border-bottom my-3"></li>
                    <div className="text-white d-flex justify-content-between mb-1">
                      <div>Fund Account balance</div>
                      <div className="text-uppercase">
                        {sellbalance
                          ? coin[1] !== campare_currency
                            ? sellbalance
                            : sellbalance
                          : 0}{" "}
                        {sellModalData?.coin1 && sellModalData?.coin1}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end gap-4">
                    <button
                      onClick={() => setIsModalOpen1(false)}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>

                    <button onClick={confirmSell} className="btn btn-success">
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Backdrop */}
        {isModalOpen1 && (
          <div className="modal-backdrop fade show" onClick={closeModal1}></div>
        )}
      </div>
      {/* end  */}
    </>
  );
}
